import getLogos from "shared/utils/getLogos";
import {
  faChartLine,
  faMapMarkerAlt,
  faUtensils,
  faMobileAlt,
  faTooth,
  faUserMd,
  faShieldAlt,
  faLaptopMedical,
  faFileInvoice,
  faMoneyBillWave,
  faUniversity,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

// Static asset imports
const navbarIcons = {
  home: "/assets/NavbarIcons/home.png",
  projects: "/assets/NavbarIcons/projects.png",
  tools: "/assets/NavbarIcons/tools.png",
  experience: "/assets/NavbarIcons/experience.png",
  thoughts: "/assets/NavbarIcons/thoughts.png",
  contact: "/assets/NavbarIcons/contact.png",
  certifications: "/assets/NavbarIcons/certifications.png",
};

const testimonialsResources = {
  devin: "/assets/Testimonials/devin.jpeg",
  musthafa: "/assets/Testimonials/Musthafa.jpeg",
};

const testimonials = [
  {
    id: 1,
    author: "Devin Picciolini",
    role: "Manager",
    description:
      "As Arslan's manager, I witnessed first-hand his exceptional talent in mobile application development. His mastery in Flutter, Native iOS, and Android was pivotal in our project successes. Arslan's ability to innovate and adapt swiftly to new technologies made a significant impact. His dedication to crafting outstanding user experiences, coupled with his efficient project management, makes him an indispensable asset to any development team. I strongly endorse Arslan for his remarkable skills and the positive influence he brings to any endeavor.",
    platform: "Linkedin",
    url: "https://www.linkedin.com/in/arslan-kaleem/details/recommendations/",
    photo: testimonialsResources.devin,
  },
  {
    id: 2,
    author: "Mohammed Musthafa",
    role: "Team Member",
    description:
      "I had the privilege of working alongside Arslan, a highly skilled mobile application developer. Arslan's expertise in Flutter, Native iOS, and Native Android development is truly commendable. His proficiency in crafting seamless and innovative mobile solutions was evident in every project we collaborated on. Arslan stands out not only for his technical prowess but also for his adaptability to new technologies and his ability to quickly grasp and apply them. In a fast-paced workplace, Arslan excelled, demonstrating his capability to efficiently work and manage projects with precision. His dedication, agility, and passion for creating exceptional user experiences make Arslan an invaluable asset to any mobile application development team. I wholeheartedly recommend Arslan for his outstanding skills and positive contributions to any project or organization.",
    platform: "Linkedin",
    url: "https://www.linkedin.com/in/arslan-kaleem/details/recommendations/",
    photo: testimonialsResources.musthafa,
  },
  {
    id: 3,
    author: "Honeydu",
    role: "Client",
    description:
      "I had the pleasure of working with Arslan Kaleem on developing the Fintech app \u201choneydu,\u201d and I'm truly impressed. Arslan's expertise in Flutter and Swift played a crucial role in bringing the app to life. He understood the unique requirements of the financial technology sector and ensured \u201choneydu\u201d met high standards of security and functionality. Arslan maintained professionalism, clear communication, and provided regular updates. The final product exceeded my expectations with a user-friendly interface, seamless financial services integration, and reliable performance. I highly recommend Arslan as an excellent Flutter and Swift developer. 10/10, five stars, and I'll definitely use his services again. Thanks for such amazing work!",
    platform: "Upwork",
    url: "https://www.upwork.com/ab/g/pub/wom/prx/eyJwZXJzb25VaWQiOiIxMzY5OTQwOTAyOTI1Njg0NzM2IiwiY29udHJhY3RSaWQiOiIzMzI2NzQyMSIsImJhbm5lclR5cGUiOiJjb250cmFjdCIsImJhbm5lclZhcmlhbnQiOiJkZWZhdWx0Iiwid29tIjoiZmx2MiIsInJlZGlyZWN0IjoiZmxfcHJvZmlsZV9wcm9tbyJ9?network=twitter",
    photo: "/assets/Testimonials/upwork.svg",
  },
];

const profileResources = {
  profilePhoto: "/assets/Profile/profile-photo.png",
  linkedin: "/assets/Profile/linkedin.png",
  github: "/assets/Profile/github.png",
  stackoverflow: "/assets/Profile/stack.png",
  email: "/assets/Profile/email.png",
  leetcode: "/assets/Profile/code.png",
  upwork: "/assets/Profile/upwork.svg",
};

const projectsResources = [
  {
    id: 0,
    title: "Vibecheck",
    name: "vibecheck",
    subtitle: "Check the vibe before you go!",
    url: "https://getvibecheck.com/",
    coverPhoto: "/assets/Projects/Vibecheck/1.png",
    images: [
      "/assets/Projects/Vibecheck/2.png",
      "/assets/Projects/Vibecheck/3.png",
      "/assets/Projects/Vibecheck/4.png",
      "/assets/Projects/Vibecheck/5.png",
      "/assets/Projects/Vibecheck/6.png",
      "/assets/Projects/Vibecheck/7.png",
    ],
    description:
      "Vibecheck is your go-to platform for discovering the atmosphere of a place before you visit. Using real-time insights, user reviews, and AI-powered analysis, Vibecheck helps users make informed decisions about restaurants, clubs, and events. Whether you're looking for a chill hangout spot or a high-energy venue, Vibecheck ensures you know what to expect.",
    highlights: [
      {
        title: "Real-time Insights",
        description:
          "AI-powered analysis combined with user reviews for live venue updates.",
        icon: faChartLine,
      },
      {
        title: "Perfect Spot Picker",
        description:
          "Find venues based on atmosphere, crowd, and energy levels.",
        icon: faMapMarkerAlt,
      },
      {
        title: "Event & Restaurant Guide",
        description: "Know before you go! Ideal for clubs, events, and dining.",
        icon: faUtensils,
      },
      {
        title: "Seamless UX",
        description:
          "Engaging and visually appealing interface for smooth navigation.",
        icon: faMobileAlt,
      },
    ],
  },
  {
    id: 1,
    title: "Total Health & Dental Care",
    name: "THDC",
    subtitle:
      "Technology, specialists, and general dentists united to protect your sunny smile.",
    url: "https://totalhealthdentalcare.com/",
    coverPhoto: "/assets/Projects/THDC/1.png",
    images: [],
    description:
      "Total Health & Dental Care (THDC) is a cutting-edge dental network that integrates advanced technology with top-tier dental specialists to offer seamless, high-quality dental care. With a focus on preventative care, digital dentistry, and patient convenience, THDC is revolutionizing the dental industry by making superior oral health services accessible and efficient.",
    highlights: [
      {
        title: "Tech-Driven Dentistry",
        description:
          "Revolutionizing oral healthcare with cutting-edge digital innovations.",
        icon: faTooth,
      },
      {
        title: "Integrated Care",
        description:
          "Bridging specialists and general dentists for comprehensive treatment.",
        icon: faUserMd,
      },
      {
        title: "Preventative Focus",
        description: "Proactive dental care to ensure long-term oral health.",
        icon: faShieldAlt,
      },
      {
        title: "Patient-Centric UX",
        description:
          "Intuitive and accessible digital experience for seamless appointments.",
        icon: faLaptopMedical,
      },
    ],
  },
  {
    id: 2,
    name: "Honeydu",
    title: "Honeydu",
    subtitle: "A Tailor-Made Invoicing Solution for Freelancers and Creators.",
    url: "https://honeydu.io/",
    coverPhoto: "/assets/Projects/Honeydu/1.png",
    images: [
      "/assets/Projects/Honeydu/2.png",
      "/assets/Projects/Honeydu/3.png",
      "/assets/Projects/Honeydu/4.png",
      "/assets/Projects/Honeydu/5.png",
      "/assets/Projects/Honeydu/6.png",
      "/assets/Projects/Honeydu/7.png",
    ],
    description:
      "Honeydu is a smart invoicing platform designed for freelancers and creative professionals. It simplifies payments, automates invoice tracking, and integrates seamlessly with banking and accounting tools. With a focus on financial transparency and ease of use, Honeydu empowers independent workers to manage their earnings effortlessly and get paid faster.",
    highlights: [
      {
        title: "Smart Invoicing",
        description:
          "Tailor-made billing solution for freelancers and creators.",
        icon: faFileInvoice,
      },
      {
        title: "Automated Payments",
        description:
          "Streamlined tracking to ensure financial transparency and efficiency.",
        icon: faMoneyBillWave,
      },
      {
        title: "Banking & Accounting Integration",
        description:
          "Seamlessly connects with financial tools for effortless management.",
        icon: faUniversity,
      },
      {
        title: "Fast & Simple Workflow",
        description: "Empowers independent workers with stress-free invoicing.",
        icon: faClock,
      },
    ],
  },
];

// Generate icons from logos
const logos = getLogos();

const icons = logos.reduce((acc, logo) => {
  acc[logo.name] = logo.src;
  return acc;
}, {});

const toolList = [
  {
    logo: icons.flutter,
    title: "Flutter",
    description: "Mobile Development",
    content: {
      overview:
        "Flutter is a UI toolkit by Google that allows me to build cross-platform mobile applications with a single codebase. It is efficient, fast, and provides a native-like experience for both Android and iOS.",
      usage:
        "I use Flutter to develop mobile applications that require smooth user interfaces and fast performance. The hot reload feature allows me to make changes and see them instantly, which speeds up development.\n\nWith Flutter, I can maintain a single codebase for Android and iOS, saving time and effort. This is especially useful when working with businesses that need apps on both platforms.\n\nFor projects that require backend communication, I integrate Flutter with Firebase or REST APIs. This enables real-time data updates and seamless connectivity.\n\nFlutter also supports custom animations and beautiful UI components, which helps me create visually appealing applications.",
      reasoning:
        "Flutter is my go-to tool for mobile app development because of its efficiency, cross-platform compatibility, and strong community support. It allows me to create high-performance applications with ease.",
    },
  },
  {
    logo: icons.swiftIcon,
    title: "Swift",
    description: "Mobile Development",
    content: {
      overview:
        "Swift is Apple's programming language for iOS development. It is fast, secure, and designed for building high-performance applications on iPhones, iPads, and Macs.",
      usage:
        "I use Swift for developing native iOS applications, ensuring they follow Apple’s design guidelines and performance standards.\n\nSwift allows me to write clean and maintainable code, making it easier to work on long-term projects. Its modern syntax improves efficiency and reduces errors.\n\nFor iOS apps that require real-time interactions, I integrate Swift with WebSockets and live data updates. This enhances user experience significantly.\n\nI also use Swift to build financial and healthcare applications, where security and performance are critical.",
      reasoning:
        "Swift is the best choice for iOS development because it offers performance, security, and a seamless experience for Apple devices. It is optimized for building fast and scalable applications.",
    },
  },
  {
    logo: icons.python,
    title: "Python",
    description: "Data Science & Backend",
    content: {
      overview:
        "Python is a versatile programming language widely used for data analysis, machine learning, and backend development. It is known for its simplicity and powerful libraries.",
      usage:
        "I use Python primarily for data analysis, handling large datasets efficiently with Pandas and NumPy.\n\nFor data visualization, I rely on Matplotlib and Seaborn to create meaningful insights from raw data.\n\nI also develop machine learning models using Scikit-learn and TensorFlow, helping businesses make data-driven decisions.\n\nOn the backend, I use Python with Django or Flask to build APIs and manage databases, ensuring seamless data flow between applications.",
      reasoning:
        "Python is my preferred language for data analysis and backend development because of its ease of use, extensive library support, and strong community backing.",
    },
  },
  {
    logo: icons.android,
    title: "Android",
    description: "Mobile Development",
    content: {
      overview:
        "Android is an open-source mobile operating system developed by Google, widely used for building mobile applications for smartphones, tablets, and other devices.",
      usage:
        "I use Android development to create applications that run efficiently on a wide range of devices.\n\nI primarily work with Kotlin and Java for developing Android applications, ensuring smooth performance and optimal memory management.\n\nFor UI/UX, I leverage Jetpack Compose and XML layouts to create visually appealing and user-friendly interfaces.\n\nI integrate Android apps with Firebase and RESTful APIs to provide real-time functionality and data synchronization across devices.",
      reasoning:
        "Android development allows me to reach a broad user base, offering flexibility in design and customization while maintaining strong compatibility with Google services.",
    },
  },
  {
    logo: icons.nodejs,
    title: "NodeJS",
    description: "Backend Development",
    content: {
      overview:
        "NodeJS is a runtime environment that allows JavaScript to run on the server side, enabling scalable and high-performance backend development.",
      usage:
        "I use NodeJS to build fast and efficient backend services for web applications.\n\nUsing Express.js, I create RESTful APIs that handle user authentication, data storage, and business logic.\n\nI integrate NodeJS with databases like PostgreSQL and MongoDB, ensuring smooth data retrieval and manipulation.\n\nFor real-time applications, I implement WebSockets with NodeJS to enable live interactions such as chat systems and notifications.",
      reasoning:
        "NodeJS is my go-to backend technology because of its event-driven architecture, scalability, and ability to handle concurrent requests efficiently.",
    },
  },
  {
    logo: icons.react,
    title: "ReactJS",
    description: "Frontend Development",
    content: {
      overview:
        "ReactJS is a JavaScript library developed by Facebook for building fast, interactive, and scalable user interfaces.",
      usage:
        "I use ReactJS to develop dynamic web applications with a component-based architecture.\n\nBy utilizing React Hooks, I manage state and side effects efficiently, making applications more interactive and responsive.\n\nFor styling, I use CSS modules and styled-components to create visually appealing interfaces with maintainable code.\n\nReact's ecosystem, including Next.js and Redux, helps me enhance performance and manage application state effectively.",
      reasoning:
        "ReactJS is my preferred frontend library because of its reusability, strong community support, and ability to build high-performance web applications with ease.",
    },
  },
  {
    logo: icons.nextjs,
    title: "NextJS",
    description: "Frontend Development",
    content: {
      overview:
        "NextJS is a React framework that enables server-side rendering and static site generation, improving performance and SEO.",
      usage:
        "I use NextJS to build high-performance web applications with efficient page rendering.\n\nNextJS allows me to implement static site generation (SSG) and server-side rendering (SSR), optimizing load times and enhancing user experience.\n\nFor APIs, I utilize NextJS API routes, streamlining backend logic within the same project.\n\nIts built-in routing system simplifies navigation, making development faster and more maintainable.",
      reasoning:
        "NextJS is my preferred React framework because it improves performance, simplifies backend integration, and enhances SEO compared to traditional React applications.",
    },
  },
  {
    logo: icons.linux,
    title: "Linux",
    description: "Operating System",
    content: {
      overview:
        "Linux is an open-source operating system widely used for development, server management, and cybersecurity.",
      usage:
        "I use Linux for software development and system administration tasks.\n\nIt provides a stable and secure environment for running web servers, databases, and cloud applications.\n\nI leverage shell scripting to automate repetitive tasks and streamline workflows.\n\nLinux package managers like apt and yum allow me to install and maintain software efficiently.",
      reasoning:
        "Linux is my preferred OS for development due to its flexibility, security, and vast open-source community support.",
    },
  },
  {
    logo: icons.microsoft,
    title: "Microsoft",
    description: "Productivity Tools",
    content: {
      overview:
        "Microsoft offers a suite of productivity tools that streamline communication, collaboration, and workflow management.",
      usage:
        "I use Microsoft Office tools like Excel, Word, and PowerPoint for documentation, data management, and presentations.\n\nMicrosoft Teams and Outlook help me manage communication and team collaboration efficiently.\n\nFor cloud storage and file sharing, I rely on OneDrive and SharePoint.\n\nI also use Power Automate to create automated workflows that improve productivity and save time on repetitive tasks.",
      reasoning:
        "Microsoft’s productivity tools are essential for efficient collaboration, organization, and workflow automation in professional environments.",
    },
  },
  {
    logo: icons.tableauIcon,
    title: "Tableau",
    description: "Data Visualization",
    content: {
      overview:
        "Tableau is a powerful data visualization tool that helps convert raw data into insightful and interactive dashboards.",
      usage:
        "I use Tableau to create dashboards that provide clear insights from complex datasets.\n\nIt allows me to connect to multiple data sources and transform data into meaningful visualizations.\n\nFor business intelligence, I design reports that help stakeholders make data-driven decisions.\n\nI leverage Tableau's calculated fields and analytics features to uncover trends and patterns in data.",
      reasoning:
        "Tableau is my preferred visualization tool because of its intuitive interface, advanced analytics capabilities, and ability to handle large datasets efficiently.",
    },
  },
  {
    logo: icons.powerbi,
    title: "PowerBI",
    description: "Data Visualization",
    content: {
      overview:
        "PowerBI is a business analytics tool by Microsoft that enables data visualization and interactive reporting.",
      usage:
        "I use PowerBI to create interactive reports that provide real-time insights into business performance.\n\nWith its built-in AI capabilities, I can uncover trends and predictive analytics.\n\nI connect PowerBI to various data sources, such as SQL databases and cloud services, to extract and analyze data.\n\nPower Query and DAX formulas help me transform and manipulate data effectively.",
      reasoning:
        "PowerBI is an essential tool for business analytics, offering advanced data modeling, visualization, and real-time reporting capabilities.",
    },
  },
  {
    logo: icons.postgresql,
    title: "PostgreSQL",
    description: "Databases",
    content: {
      overview:
        "PostgreSQL is an advanced open-source relational database known for its reliability, scalability, and performance.",
      usage:
        "I use PostgreSQL for managing structured data efficiently.\n\nIt supports ACID transactions, ensuring data integrity in applications.\n\nI optimize queries and indexes to enhance database performance.\n\nPostgreSQL's support for JSON allows me to handle both relational and semi-structured data seamlessly.",
      reasoning:
        "PostgreSQL is my preferred database because of its powerful querying capabilities, stability, and strong community support.",
    },
  },
  {
    logo: icons.azure,
    title: "Azure",
    description: "Cloud Computing",
    content: {
      overview:
        "Microsoft Azure is a cloud computing platform that provides a wide range of services for hosting, data storage, and AI-driven applications.",
      usage:
        "I use Azure for deploying scalable applications in the cloud.\n\nAzure Virtual Machines allow me to run applications efficiently with cloud-based computing power.\n\nFor secure and managed databases, I utilize Azure SQL Database.\n\nI integrate Azure Cognitive Services for AI-driven insights and automation.",
      reasoning:
        "Azure is my go-to cloud platform due to its enterprise-grade security, hybrid capabilities, and seamless integration with Microsoft tools.",
    },
  },
  {
    logo: icons.aws,
    title: "Amazon AWS",
    description: "Cloud Computing",
    content: {
      overview:
        "Amazon AWS is a cloud computing platform that offers scalable infrastructure for web applications, storage, and AI services.",
      usage:
        "I use AWS to deploy and manage scalable applications in the cloud.\n\nAWS Lambda allows me to run serverless functions without managing infrastructure.\n\nI set up EC2 instances for hosting and S3 for secure file storage.\n\nFor databases, I use RDS and DynamoDB to handle structured and unstructured data efficiently.",
      reasoning:
        "AWS is my go-to cloud provider because of its scalability, security, and wide range of services that cater to various project needs.",
    },
  },
];

const finalToolList = toolList
  .filter((tool) => tool.logo)
  .map((tool, index) => ({
    id: index + 1,
    ...tool,
  }));

const filteredLogos = logos.filter(
  (logo) => !logo.name.toLowerCase().includes("icon")
);

export {
  navbarIcons,
  profileResources,
  projectsResources,
  finalToolList,
  filteredLogos,
  testimonialsResources,
  testimonials,
};
